interface CoverMediaProps {
  src?: string;
  alt: string;
}

export function CoverMedia({ src, alt }: CoverMediaProps) {
  if (!src) return null;

  return (
    <div className="mt-6 px-5 md:px-8">
      <div className="overflow-hidden bg-dotted">
        <img
          src={src}
          alt={alt}
          className="max-h-[min(420px,55vh)] w-full object-contain md:max-h-[min(480px,50vh)]"
          loading="eager"
        />
      </div>
    </div>
  );
}
